var map = {
	"./google-laurel-da-DK.svg": 54254,
	"./google-laurel-de-DE.svg": 88219,
	"./google-laurel-en-GB.svg": 76881,
	"./google-laurel-en-US.svg": 43926,
	"./google-laurel-es-ES.svg": 56013,
	"./google-laurel-es-MX.svg": 23726,
	"./google-laurel-fr-FR.svg": 29489,
	"./google-laurel-it-IT.svg": 52603,
	"./google-laurel-nb-NO.svg": 50028,
	"./google-laurel-nl-NL.svg": 79417,
	"./google-laurel-pl-PL.svg": 48317,
	"./google-laurel-pt-BR.svg": 95109,
	"./google-laurel-pt-PT.svg": 74493,
	"./google-laurel-sv-SE.svg": 33568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;